/* 🤖 this file was generated by svg-to-ts */
export const kzIconsOthers: {
  name: 'others';
  data: string;
} = {
  name: 'others',
  data: `<svg viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5"><circle cx="6.694" cy="12" r=".5" stroke="currentColor" stroke-width="1px"/><circle cx="17.306" cy="12" r=".5" stroke="currentColor" stroke-width="1px"/><circle cx="12" cy="12" r=".5" stroke="currentColor" stroke-width="1px"/></svg>`
};
